export default theme => ({
    downloadButton: {
        color: theme.palette.blue[500],
        fontWeight: 700
    }
});
